import RECORRIDOS from "./recorridos.json";

export const ADDRESS = "Terminal Retiro Boletería xx";
export const PHONE = "xxxxxxxxxx";
export const WHATSAPP_NUMBER = "xxxxxxxxxx";
export const WHATSAPP_URL = `https://api.whatsapp.com/send/?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent("Hola Santiagueño, quiero hacer una consulta")}`;
// Redes de Santiagueño: completar cuando el dueño pase los usuarios (vacío = no se muestran).
export const INSTAGRAM_URL = "";
export const FACEBOOK_URL = "";

export const PUNTOENVIO = {
  url: "https://puntoenvio.com",
  quoteUrl: "https://puntoenvio.com/cotizador",
  address: ADDRESS,
  phone: PHONE,
  whatsapp: WHATSAPP_NUMBER,
  email: "admin@puntoenvio.com",
};

export const CITIES = [
  "Buenos Aires", "Rosario", "Santa Fe", "Añatuya", "Quimilí", "La Banda", "Santiago del Estero",
  "Termas de Río Hondo", "Frías", "Tucumán", "Nueva Esperanza", "Monte Quemado",
];

export const NAV = [
  { to: "/", label: "Inicio" },
  { to: "/pasajes", label: "Pasajes" },
  { to: "/destinos", label: "Destinos" },
  { to: "/agencias", label: "Agencias" },
  { to: "/puntoenvio", label: "Encomiendas" },
  { to: "/contacto", label: "Contacto" },
];

export const DESTINOS = [
  { city: "Santiago del Estero", tag: "Madre de Ciudades", img: "/img/santiago.jpg", from: "Desde $67.500" },
  { city: "Buenos Aires", tag: "Virrey del Pino · Liniers · Retiro · Pacheco", img: "/img/baires.jpg" },
  { city: "Tucumán", tag: "Jardín de la República", img: "/img/tucuman.jpg" },
  { city: "Termas de Río Hondo", tag: "Aguas termales", img: "/img/termas.jpg" },
  { city: "Frías, Nueva Esperanza y Monte Quemado", tag: "Interior santiagueño", img: "/img/interior.jpg", to: "/destinos" },
];

export const INCLUDES = [
  "WiFi satelital durante el viaje", "Hasta 15 kg en bodega", "Carga USB en tu butaca",
  "Elegís tu butaca al comprar", "Climatización todo el trayecto", "Algo rico para el camino",
];

export const TARIFAS = [
  { tag: "Semicama · piso de arriba", route: "Retiro → Santiago del Estero", price: "$67.500", recline: "130°" },
  { tag: "Semicama · piso de arriba", route: "Retiro → Nueva Esperanza", price: "$79.000", recline: "130°" },
  { tag: "Coche cama · más espacio", route: "Retiro → Santiago del Estero", price: "$89.500", recline: "160°", featured: true },
];

// Recorridos reales (Recorridos_semanales.xlsx) y tarifas entre ciudades (Tarifario.xlsx): stops = [parada, hora, ciudad]
export const ROUTES = RECORRIDOS.routes;
export const CITY_PRICES = RECORRIDOS.prices;

export const AGENCIAS = [
  { id: "retiro", type: "boleteria", name: "Terminal Retiro", city: "CABA", address: "Terminal Retiro Boletería xx", whatsapp: "xxxxxxxxxx", phone: "xxxxxxxxxx", lat: -34.5888791, lng: -58.3725396 },
  { id: "el-talar", type: "boleteria", name: "Terminal El Talar", city: "El Talar, Bs. As.", address: "Terminal de Ómnibus · Boletería Nº 26", whatsapp: "11 7148-3419", lat: -34.4730963, lng: -58.6556263 },
  { id: "san-justo", type: "boleteria", name: "Terminal San Justo · Monseñor", city: "San Justo, Bs. As.", address: "Terminal de Ómnibus de San Justo · Boletería Nº 1", whatsapp: "11 6669-8896", lat: -34.6847127, lng: -58.5608888 },
  { id: "campana", type: "agencia", name: "Campana", city: "Campana, Bs. As.", address: "Pedro Siri 1753", whatsapp: "348 930-2033", lat: -34.1899166, lng: -58.9471538 },
  { id: "la-noria", type: "boleteria", name: "Terminal Pte. La Noria", city: "Puente La Noria, Bs. As.", address: "Terminal Ómnibus Pte. La Noria · Boletería Nº 7", whatsapp: "11 3121-3003", lat: -34.70719, lng: -58.4538 },
  { id: "merlo", type: "agencia", name: "Merlo · NYC Travel", city: "Merlo, Bs. As.", address: "NYC Travel Merlo", whatsapp: "11 2819-0841", lat: -34.6653511, lng: -58.7268467 },
  { id: "moron", type: "agencia", name: "Morón · NYC Travel", city: "Morón, Bs. As.", address: "NYC Travel Morón", whatsapp: "11 3950-5311", lat: -34.6491633, lng: -58.6172109 },
  { id: "puntoenvio-central", type: "puntoenvio", name: "PuntoEnvío Central", city: "CABA", address: "Terminal Retiro Boletería xx", whatsapp: "xxxxxxxxxx", phone: "xxxxxxxxxx", lat: -34.5888791, lng: -58.3730396 },
  { id: "fernandez", type: "boleteria", name: "Terminal Fernández", city: "Fernández, Santiago del Estero", address: "Terminal de Ómnibus de Fernández · Boletería Nº 20", whatsapp: "11 2186-0043", lat: -27.9167041, lng: -63.8875734 },
  { id: "santiago", type: "boleteria", name: "Terminal Santiago del Estero", city: "Santiago del Estero", address: "Terminal de Ómnibus · Boleterías Nº 20 y 25", lat: -27.778485, lng: -64.263444 },
  { id: "la-banda", type: "boleteria", name: "Terminal La Banda", city: "La Banda, Santiago del Estero", address: "Terminal de Ómnibus La Banda · Boletería Nº 12", whatsapp: "385 537-4780", lat: -27.7355019, lng: -64.249376 },
  { id: "pozo-hondo", type: "boleteria", name: "Terminal Pozo Hondo", city: "Pozo Hondo, Santiago del Estero", address: "Terminal de Ómnibus Pozo Hondo · Boletería Nº 9", whatsapp: "385 577-0196", lat: -27.1635825, lng: -64.4897967 },
  { id: "nueva-esperanza", type: "boleteria", name: "Terminal Nueva Esperanza", city: "Nueva Esperanza, Santiago del Estero", address: "Terminal de Ómnibus · pasajes por WhatsApp", whatsapp: "11 3443-8090", lat: -26.2000497, lng: -64.2406947 },
  { id: "termas", type: "boleteria", name: "Terminal Termas de Río Hondo", city: "Termas de Río Hondo", address: "Nueva Terminal de Ómnibus · Boletería Nº 8", whatsapp: "385 844-4191", lat: -27.485051, lng: -64.875671 },
  { id: "tucuman", type: "boleteria", name: "Terminal Tucumán", city: "San Miguel de Tucumán", address: "Terminal de Ómnibus de Tucumán · Boletería Nº 19", lat: -26.8351274, lng: -65.1941185 },
];

export const formatARS = (n) => `$${Number(n ?? 0).toLocaleString("es-AR")}`;
